import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';

const Widget = React.forwardRef(({ title, children, className = '', hideTitle = false, ...props }, ref) => {
  return (
    <Card ref={ref} {...props} className={`h-full w-full flex flex-col border-0 bg-transparent ${className}`}>
      {!hideTitle && (
        <CardHeader className="px-0 pt-0 pb-2">
          <CardTitle className="text-lg font-semibold">{title}</CardTitle>
        </CardHeader>
      )}
      <CardContent className="flex-grow p-0 overflow-hidden min-w-0">
        {children}
      </CardContent>
    </Card>
  );
});

export default Widget;
